import { render, staticRenderFns } from "./LoadMoreData.vue?vue&type=template&id=f500ddf0&"
import script from "./LoadMoreData.vue?vue&type=script&lang=js&"
export * from "./LoadMoreData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports